import _classCallCheck from "/home/rewyer/sites/rewyer-client-admin/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/rewyer/sites/rewyer-client-admin/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/rewyer/sites/rewyer-client-admin/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/rewyer/sites/rewyer-client-admin/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/rewyer/sites/rewyer-client-admin/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
 * @license Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module horizontal-line/horizontallineediting
 */
import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import HorizontalLineCommand from './horizontallinecommand';
import { toWidget } from '@ckeditor/ckeditor5-widget/src/utils';
import '../theme/horizontalline.css';
/**
 * The horizontal line editing feature.
 *
 * @extends module:core/plugin~Plugin
 */

var HorizontalLineEditing = /*#__PURE__*/function (_Plugin) {
  _inherits(HorizontalLineEditing, _Plugin);

  var _super = _createSuper(HorizontalLineEditing);

  function HorizontalLineEditing() {
    _classCallCheck(this, HorizontalLineEditing);

    return _super.apply(this, arguments);
  }

  _createClass(HorizontalLineEditing, [{
    key: "init",
    value:
    /**
     * @inheritDoc
     */
    function init() {
      var editor = this.editor;
      var schema = editor.model.schema;
      var t = editor.t;
      var conversion = editor.conversion;
      schema.register('horizontalLine', {
        isObject: true,
        allowWhere: '$block'
      });
      conversion.for('dataDowncast').elementToElement({
        model: 'horizontalLine',
        view: function view(modelElement, viewWriter) {
          return viewWriter.createEmptyElement('hr');
        }
      });
      conversion.for('editingDowncast').elementToElement({
        model: 'horizontalLine',
        view: function view(modelElement, viewWriter) {
          var label = t('Horizontal line');
          var viewWrapper = viewWriter.createContainerElement('div');
          var viewHrElement = viewWriter.createEmptyElement('hr');
          viewWriter.addClass('ck-horizontal-line', viewWrapper);
          viewWriter.setCustomProperty('hr', true, viewWrapper);
          viewWriter.insert(viewWriter.createPositionAt(viewWrapper, 0), viewHrElement);
          return toHorizontalLineWidget(viewWrapper, viewWriter, label);
        }
      });
      conversion.for('upcast').elementToElement({
        view: 'hr',
        model: 'horizontalLine'
      });
      editor.commands.add('horizontalLine', new HorizontalLineCommand(editor));
    }
  }], [{
    key: "pluginName",
    get:
    /**
     * @inheritDoc
     */
    function get() {
      return 'HorizontalLineEditing';
    }
  }]);

  return HorizontalLineEditing;
}(Plugin); // Converts a given {@link module:engine/view/element~Element} to a horizontal line widget:
// * Adds a {@link module:engine/view/element~Element#_setCustomProperty custom property} allowing to
//   recognize the horizontal line widget element.
// * Calls the {@link module:widget/utils~toWidget} function with the proper element's label creator.
//
//  @param {module:engine/view/element~Element} viewElement
//  @param {module:engine/view/downcastwriter~DowncastWriter} writer An instance of the view writer.
//  @param {String} label The element's label.
//  @returns {module:engine/view/element~Element}


export { HorizontalLineEditing as default };

function toHorizontalLineWidget(viewElement, writer, label) {
  writer.setCustomProperty('horizontalLine', true, viewElement);
  return toWidget(viewElement, writer, {
    label: label
  });
}